module.exports = __webpack_public_path__ + "static/img/award4.a1ff8d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/award4.png
// module id = w4fX
// module chunks = 7